import { createFetcher } from '@composables/createFetcher';

// Fetcher-specific types
type LoginPayload = {
  email: string;
  password: string;
};

type MagicLinkPayload = {
  token: string;
};

type ChangePasswordPayload = {
  password: string;
};

type ChangeEmailPayload = {
  email: string;
};

type SignUpPayload = {
  password: string;
};

type SendChangeEmailPayload = {
  email: string;
  returnUrl: string;
};

type SendForgotPasswordPayload = {
  email: string;
  returnUrl: string;
};

type SendMagicLinkPayload = {
  email: string;
  returnUrl: string;
};

type SendSignUpPayload = {
  email: string;
  returnUrl: string;
};

export const useAccountFetcher = () => {
  return {
    login: createFetcher<LoginPayload>({
      endpoint: '/fan/login',
      requiresArtistId: true,
    }),
    magicLink: createFetcher<MagicLinkPayload>({
      endpoint: '/fan/login/magic-link',
      requiresAuth: true,
      requiresArtistId: true,
    }),
    changePassword: createFetcher<ChangePasswordPayload>({
      endpoint: '/fan/login/change-password',
      requiresAuth: true,
      requiresArtistId: true,
    }),
    changeEmail: createFetcher<ChangeEmailPayload>({
      endpoint: '/fan/login/change-email',
      requiresAuth: true,
    }),
    signUp: createFetcher<SignUpPayload>({
      endpoint: '/fan/signup',
      requiresAuth: true,
      requiresArtistId: true,
    }),
    sendChangeEmail: createFetcher<SendChangeEmailPayload>({
      endpoint: '/fan/email/change-email',
      requiresAuth: true,
      requiresArtistId: true,
    }),
    sendForgotPassword: createFetcher<SendForgotPasswordPayload>({
      endpoint: '/fan/email/forgot-password',
      requiresArtistId: true,
    }),
    sendMagicLink: createFetcher<SendMagicLinkPayload>({
      endpoint: '/fan/email/magic-link',
      requiresArtistId: true,
    }),
    sendSignUp: createFetcher<SendSignUpPayload>({
      endpoint: '/fan/email/signup',
      requiresArtistId: true,
    }),
  };
};
